import { getCookie } from '@/features/shared/utils/cookies'
import { isOnServer } from '@shared/constants/util'

/**
 * Cookie name for Comet Partner Attribute as specified in Perplexity documentation
 */
export const CPA_COOKIE_NAME = 'cpa'

/**
 * Type definition for CPA (Comet Partner Attribute) data
 */
export interface CPAData {
  comet_token?: string
  /**
   * True if the CPA cookie is present (browser is likely Comet), false otherwise
   */
  unverified_is_comet: boolean
}

/**
 * Gets the CPA cookie value if it exists
 *
 * @returns string | null - the CPA cookie value or null if not present
 */
export function getCPACookieValue(): string | null {
  if (isOnServer()) return null

  return getCookie(CPA_COOKIE_NAME)
}

/**
 * Gets comprehensive CPA data for analytics purposes
 *
 * @returns CPAData object containing comet token if present
 */
export function getCPAData(): CPAData {
  const rawValue = getCPACookieValue()
  const hasCookie = !!rawValue
  return {
    ...(hasCookie && { comet_token: rawValue }),
    unverified_is_comet: hasCookie,
  }
}
